// extracted by mini-css-extract-plugin
export var container = "_c5-0";
export var popoverContent = "_c5-1";
export var tosLink = "_c5-2";